export const HORAS_TRABAJO_FORMULA = 176;
export const DIAS_ORDINARIO_TRABAJO_FORMULA = 22;


export function CalcularFraccionHoraDia(horasSolicitadas: number) {
    const calculoFormulaFraccionHoraDia = (horasSolicitadas * DIAS_ORDINARIO_TRABAJO_FORMULA) / HORAS_TRABAJO_FORMULA;
    return +calculoFormulaFraccionHoraDia.toFixed(2);
}